import { KeyValueModel } from "../../model";
import { EnumTpServicoProduto } from "../../model/enums/enum-tp-servico-produto";

export const TpServicoProdutoMock: KeyValueModel[] = [
  new KeyValueModel(EnumTpServicoProduto.Invalido, "Invalido"),
  new KeyValueModel(EnumTpServicoProduto.Proprio, "Proprio"),
  new KeyValueModel(EnumTpServicoProduto.Interno, "Interno"),
  new KeyValueModel(EnumTpServicoProduto.Externo, "Externo"),
];
